import { useEffect, useState } from "react";
import { getImageProcessingSettings } from "../features/settings/api/imageProcessingSettingsApi";
import { formatBytesLabel } from "./formatBytes";

let cachedLimits = null;
let cachePromise = null;

/** Fetch module upload limits from imageProcessing.runtime.json (via API). */
export async function fetchImageProcessingLimits() {
  if (cachedLimits) return cachedLimits;
  if (!cachePromise) {
    cachePromise = getImageProcessingSettings()
      .then((payload) => {
        const data = payload?.data || payload || {};
        cachedLimits = {
          default: data.default || null,
          categories: data.categories || {},
        };
        return cachedLimits;
      })
      .catch(() => {
        cachePromise = null;
        return null;
      });
  }
  return cachePromise;
}

export function useCategoryUploadLimit(categoryKey) {
  const [maxBytes, setMaxBytes] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchImageProcessingLimits().then((limits) => {
      if (cancelled || !limits) return;
      const value =
        limits.categories?.[categoryKey]?.maxBytes ?? limits.default?.maxBytes ?? null;
      setMaxBytes(value);
    });
    return () => {
      cancelled = true;
    };
  }, [categoryKey]);

  return maxBytes;
}

export function formatCategoryLimitLabel(maxBytes) {
  if (!Number.isFinite(maxBytes)) return "admin-configured limit";
  return formatBytesLabel(maxBytes);
}
